#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.subtitle {
  color: var(--main-titles-inputs-600);
}

#activated-modules {
  display: flex;
  flex-direction: column;

  gz-checkbox {
    margin-top: calc(var(--spacer) * 3);
    opacity: 1;
  }

  .module-info-text {
    margin: calc(var(--spacer) * 1) 0 0 26px;
    padding: 0;
    color: var(--main-titles-inputs-600);
    font-size: var(--body-size);
    line-height: 1.5;

    span {
      font-family: var(--font-family-secondary);
    }
  }
}
